import { IDemoAttributionParams } from '@webtrader/core/api/user/demoAccount';

import { IDeepLinkData } from './types';

interface IAppsFlyerDeepLinkParams {
  pid?: string; // Publisher ID / Media Source
  c?: string; // Campaign ID
  af_ad?: string; // Ad ID
  af_xp?: string; // Custom parameter
  deep_link_value?: string; // Deep link value
}

export const parseDeepLinkUrl = (url: string): IAppsFlyerDeepLinkParams => {
  try {
    const urlObj = new URL(url);
    const params: IAppsFlyerDeepLinkParams = {};

    // Extract parameters from URL
    urlObj.searchParams.forEach((value, key) => {
      switch (key) {
        case 'pid':
          params.pid = value;
          break;
        case 'c':
          params.c = value;
          break;
        case 'af_ad':
          params.af_ad = value;
          break;
        case 'af_xp':
          params.af_xp = value;
          break;
        case 'deep_link_value':
          params.deep_link_value = value;
          break;
      }
    });

    return params;
  } catch (error) {
    console.error('APPSFLYER - Error parsing deep link URL:', error);
    return {};
  }
};

export interface IAttributionFields {
  appsFlyerAttribute?: IDemoAttributionParams;
}

export const buildAttributionFields = (attribution?: IDeepLinkData | null): IAttributionFields => {
  const appsFlyerAttribute: IDemoAttributionParams | undefined = attribution?.mediaSource
    ? {
        pId: attribution.mediaSource,
        afSub: attribution.afSub,
        afKeyword: attribution.afKeyword,
        afAdFormat: attribution.afAdFormat,
        clickId: attribution.clickid
      }
    : undefined;

  return { appsFlyerAttribute };
};
